var finn = {
  search_option: function(){
    
    $('form.custom_search').on('submit', function(e){
      e.preventDefault();
      var serch_value = $(this).find('.search_value').val();
      
      $('.blog_posts').html('');
      $('.pagination').hide();
      
        $.each(search_array, function(key, val){
         
          if(typeof val.title !== 'undefined' && serch_value != ''){
             var title = val.title.toLowerCase();
            serch_value = serch_value.toLowerCase();
            
            var description = val.description;;
            if (description.length > 1) {
              description = description.toLowerCase();
            }
            
            if(title.indexOf(serch_value) > -1 ) {
               add_html(val);
            }else if( description.indexOf(serch_value) > -1){
              add_html(val);
            }
          }
      });
      
      
    });
    
    
    function add_html(value){
      
      var html = '<div class="custome-blog grid__item one-half ajax_loading"> <div class="article--listing">';
      
      		if(typeof value.img !== 'undefined') { 
              html +='<div  class="article__list-image-wrapper js">'+
                     '<a href="'+value.url+'" class="article__list-image-container">'+
                      '<img class="article__list-image lazyautosizes lazyloaded" src="'+value.img+'" alt="'+value.title+'"/>'+
                    '</a>'+
                    
                    '<div class="btn_read_more">'+
                       '<div class="btn_read_more_inner">'+
                        '<a href="'+value.url+'"> Read more </a>'+
                     ' </div>'+
                    '</div>'+                    
                  '</div>';
            }
     		 if(typeof value.title !== 'undefined') { 
               html += '<h2 class="article__title h3">'+	
                    	 '<a href="'+value.url+'">'+value.title+'</a>'+
                  	   '</h2>';
                }
            if(value.short_description != '') { 
               html += '<div class="rte">'+value.short_description+'</div>';
            }else if(typeof value.description !== 'undefined'){
              var description = value.description;
              if (description.length > 100) {
                description =description.substr(0, description.lastIndexOf(' ', 97)) + '...';
              }
              
              html += '<div class="rte">'+description+'</div>';
            }
      
      
          		 '</div></div>';
      
       $('.blog_posts').append(html);
      
    }
    
    
  }
}

$(function(){
  finn.search_option();
  
});